import { Component, OnInit, input } from '@angular/core';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatDivider } from '@angular/material/divider';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatToolbar } from '@angular/material/toolbar';
import { RouterModule } from '@angular/router';
import { AuthService } from 'src/app/core/services/auth.service';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss'],
  imports: [
    MatToolbar,
    RouterModule,
    MatIcon,
    MatButton,
    MatIconButton,
    MatMenu,
    MatMenuItem,
    MatMenuTrigger,
    MatDivider,
  ],
})
export class NavComponent implements OnInit {
  public readonly admin = input(false);
  public role = false;
  public username = '';
  public avatarInitial = '?';

  constructor(private authService: AuthService) {}

  ngOnInit(): void {
    this.authService.getCurrentUser().then((user) => {
      const roles: string = user.attributes['custom:roles'] ?? '';
      if (roles.includes('Admin') && roles.includes('Developer')) {
        this.role = true;
      }
      const email: string = user.attributes?.email ?? '';
      this.username = email.split('@')[0] ?? '';
      this.avatarInitial = this.username.charAt(0).toUpperCase() || '?';
    });
  }

  logout(): void {
    this.authService.signOut();
  }
}
